module.exports = __webpack_public_path__ + "02_short_gold.ffc6c09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_short_gold.png
// module id = nkyg
// module chunks = 0